import React, { useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";

const AllBatch = ({ setAvailableBatches, availableBatches, availableJobs }) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };
  console.log("allbacthesAudit", availableBatches);

  // Handle the logic to update batches with jobs
  useEffect(() => {
    if (availableJobs && availableBatches.length > 0) {
      // Map and initialize batches
      const updatedBatches = availableBatches.map((batch) => ({
        ...batch,
        jobs: [], // Initialize jobs array for each batch
      }));

      // Group jobs under their respective batches
      availableJobs.forEach((job) => {
        const batch = updatedBatches.find(
          (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
        );
        if (batch) {
          batch.jobs.push(job);
        }
      });

      // Calculate dateRange for each batch
      const batchesWithDateRanges = updatedBatches.map((batch) => {
        if (batch.jobs.length > 0) {
          const jobDates = batch.jobs.map((job) => ({
            start: new Date(job.jobStartingDate),
            end: new Date(job.jobCompletionDate),
          }));

          // Find the earliest start date and latest end date
          const earliestStartDate = new Date(
            Math.min(...jobDates.map((date) => date.start))
          );
          const latestEndDate = new Date(
            Math.max(...jobDates.map((date) => date.end))
          );

          // Format the dateRange
          const formattedDateRange = `${earliestStartDate.toLocaleDateString()} - ${latestEndDate.toLocaleDateString()}`;

          return {
            ...batch,
            dateRange: formattedDateRange,
          };
        }

        // No jobs, no dateRange
        return {
          ...batch,
          dateRange: "No Dates Available",
        };
      });

      // Update state only if batches are changed
      setAvailableBatches((prevBatches) => {
        const prevBatchesString = JSON.stringify(prevBatches);
        const updatedBatchesString = JSON.stringify(batchesWithDateRanges);
        if (prevBatchesString !== updatedBatchesString) {
          return batchesWithDateRanges;
        }
        return prevBatches;
      });
    }
  }, [availableJobs, availableBatches, setAvailableBatches]); // Include all dependencie

  return (
    <Grid className={`${styles.scrollableContainer}`}>
      {availableBatches?.length > 0 ? (
        availableBatches?.map((batch, index) => (
          <Grid item xs={12} md={12} key={index} my={1} mx={2}>
            <Accordion expanded={expandedBatch === batch.batchTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton onClick={handleAccordionToggle(batch.batchTitle)}>
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
              >
                <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                  {/* Section 1: Batch Title */}
                  <div className="flex">
                    <h1 className={`${styles.batchTitle}`}>
                      {batch.batchTitle}
                    </h1>
                  </div>

                  {/* Section 2: Other Details */}
                  <div className="flex items-center gap-6">
                    {/* Date Range */}
                    <Chip label={batch.dateRange} className={styles.chip} />

                    {/* User Info */}
                    <Chip label={batch.contact} className={styles.chip} />

                    {/* Status Badge */}
                    <Chip label={batch.status} className={styles.pending} />

                    {/* Ellipsis Button */}
                    <button className="text-gray-400 hover:text-gray-600 text-xl">
                      ⋮
                    </button>
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails className={styles.accordionDetails}>
                {/* Render Job Details Table */}
                <Box className={`${styles.scrollableBox}`}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow className={styles.tableHeader}>
                          <TableCell className={styles.tableCell}>
                            ADDRESS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            STORE MANAGER
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            JOB DATE
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            JOB PAY
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            KAM APPROVAL
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            SITE REPORT
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            JOB STATUS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            IP PAY
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {batch?.jobs?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row?.address}
                              </div>
                              <div className={styles.address2}>{row.city}</div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.storeOwnerName}
                              </div>
                              <div className={styles.storeManagerContact}>
                                {row.storeOwnerPhoneNumber}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.jobDate}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                ₹{row.jobPay}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.kamApproval}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <div className={styles.linkWithImage}>
                                <img
                                  src={PdfIcon}
                                  alt="PDF Icon"
                                  className={styles.icon}
                                />
                                <a href="#" className={styles.link}>
                                  {row.SiteReport}
                                </a>
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={row.jobStatus}
                                className={styles.pending}
                              />
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={row.ipPay}
                                className={styles.pending}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </AccordionDetails>
              {/* <BatchActions /> */}
            </Accordion>
          </Grid>
        ))
      ) : (
        <Typography
          variant="h6"
          align="center"
          className={`${styles.noJobsBox} ${styles.noJobsText}`}
          style={{ margin: "2rem 0" }}
        >
          No Batches Available
        </Typography>
      )}
    </Grid>
  );
};
export default AllBatch;
